import React, { Component, Fragment } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { selectFeature } from "~/store/features/featuresActions";

const Desktop = Loadable({
  loader: () =>
    import(/* desktop */ "~/components/desktop/pages/ChooseFeatureBooking"),
  loading: LoadableLoading,
  delay: 10
});

class ChooseFeatureBooking extends Component {
  methods = {
    handleChooseFeature: item => {
      this.props.selectFeature(item.type);
    },
    handleGoBack: () => {
      const { history } = this.props;
      history.push("/chon-benh-vien");
    }
  };

  render() {
    return (
      <Fragment>
        <Desktop {...this.props} {...this.methods} />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    user: { IsAuthenticated },
    features: {
      allFeatures: { list: listFeatures, loading }
    }
  } = state;
  return {
    device: type,
    listFeatures,
    loading,
    IsAuthenticated
  };
};

const ChooseFeatureBookingHelmet = withTitle({
  component: ChooseFeatureBooking,
  title: "Medpro | Chọn hình thức đăt khám"
});

export default withRouter(
  connect(mapStateToProps, {
    selectFeature
  })(ChooseFeatureBookingHelmet)
);
